// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag-module--tag--2Oyrs","tagActive":"tag-module--tag--active--3cj-c"};